angular.module('zc.zenclerkS')

  .component('zcsCampaignTemplateDynamicView', {
    bindings: {
      project: '<',
      campaign: '<',
      onlyViews: '<'
    },
    templateUrl: '/templates/zenclerk_s/directives/campaign/template_editor/campaign_template_dynamic_view.html',
    controller: zcsCampaignTemplateDynamicViewController
  });

zcsCampaignTemplateDynamicViewController.$inject = ['$q', '$sce', '$scope', '$timeout', '$translate', 'CampaignTemplate', 'Template'];
function zcsCampaignTemplateDynamicViewController($q, $sce, $scope, $timeout, $translate, CampaignTemplate, Template) {
  const vm = this;

  vm.$onInit = () => {
    vm.viewShow = false;

    vm.offerView = $translate.instant('directives.campaign.templateEditor.dynamicView.offerView');
    vm.isOfferViewInstructionVisible = false;
    vm.offerViewInstruction = `
      <div class="text-justify">
        ${$translate.instant('directives.campaign.templateEditor.dynamicView.offerViewInstruction', { discount: '◯◯円OFF' })}
      </div>
    `;

    vm.presentView = $translate.instant('directives.campaign.templateEditor.dynamicView.presentView');
    vm.isPresentViewInstructionVisible = false;
    vm.presentViewInstruction = `
      <div class="text-justify">
        ${$translate.instant('directives.campaign.templateEditor.dynamicView.presentViewInstruction')}
      </div>
    `;

    Template.all(vm.project.id).then(res => {
      vm.baseTemplates = res;

      // set initial template
      if(vm.campaign.template_type && !vm.campaign.template) {
        vm.campaign.template = _.find(vm.baseTemplates, d => d.name === vm.campaign.template_type);
      }

      $scope.$watch('$ctrl.campaign.template', updateTemplate, true);
      $scope.$watch('$ctrl.campaign.element', updateView, true);
    });
  };

  function updateView() {
    if(!vm.campaign.template_type) { return }
    const params = {
      project_id: vm.project.id,
      campaign_id: vm.campaign.id,
      template_type: vm.campaign.template_type,
      campaign_type: vm.campaign.campaign_type,
      message: vm.campaign.element.message,
      element: vm.campaign.element
    };

    return CampaignTemplate.views(angular.extend(params))
      .then(views => {
        // Choose the view always in lite
        const view = $('<div>').append(_.find(views, d => d.file === 'index').view);
        if(vm.campaign.coupon_code) {
          view.find('.zc_code_insert_code').text(vm.campaign.coupon_code);
        } else if((vm.campaign.incentives[0] != null ? vm.campaign.incentives[0].coupon_code : undefined)) {
          view.find('.zc_code_insert_code').text(vm.campaign.incentives[0].coupon_code);
        } else if(vm.campaign.incentive_draft.coupon_code) {
          view.find('.zc_code_insert_code').text(vm.campaign.incentive_draft.coupon_code);
        } else {
          view.find('.zc_code_insert_code').text('COUPONCODE');
        }
        vm.view = $sce.trustAsHtml(view.html()); // currently there is only one view
        vm.hasHtmlError = false;
      }).catch(err => {
        vm.hasHtmlError = true;
      }).finally(() => {

        const cssPromises = [
          CampaignTemplate.confirmJs(params),
          CampaignTemplate.css(angular.extend(params)),
          CampaignTemplate.confirmCss(params)
        ];

        return $q.all(cssPromises)
          .then((...args) => {
            // add random number that ensures that js content has changed and re-executed
            const [js, ...css] = Array.from(args[0]);
            vm.js = $sce.trustAsHtml(`<script data-random="${Math.random()}">${js}</script>`);
            vm.css = css.join('\n');
            vm.hasCssError = false;
          }

          //setTemplat eValid true
          // This is to set a dynamic height on coupon view
          // $timeout () ->
          //   for view in vm.views
          //     view.height = angular.element(document.querySelector(".#{view.class}"))[0].offsetHeight
          //     console.log view.height
          ).catch(err => {
            vm.hasCssError = true;
          });
      });
  }
  //setTemplateValid false

  function updateTemplate(newval, oldval) {
    vm.viewShow = false;
    $timeout(() => {
      vm.viewShow = true;
    }, 500); // add timeout to avoid template flickering while appending the html/css code

    if(newval) {
      const baseTemplate = _.find(vm.baseTemplates, {
        name: vm.campaign.template_type
      });

      vm.campaign.template = baseTemplate;

      if(!vm.onlyViews) {
        vm.views = vm.campaign.template.views;
      } else {
        vm.views = _.map(vm.onlyViews, d => vm.campaign.template.views[d]);
      }
      return updateView();
    }
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/campaign/template_editor/campaign_template_dynamic_view.js